import { render, staticRenderFns } from "./OffersContainer.vue?vue&type=template&id=dca9108a&scoped=true"
import script from "./OffersContainer.vue?vue&type=script&lang=js"
export * from "./OffersContainer.vue?vue&type=script&lang=js"
import style0 from "./OffersContainer.vue?vue&type=style&index=0&id=dca9108a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dca9108a",
  null
  
)

export default component.exports